<!-- Float button -->
<div class="kalgudi-float-button" fxHide.gt-xs>
  <div class="float-button mb-3">
    <button class="kl-float-button" mat-fab [color]="color || 'accent'" (click)="onClick($event)">
      <mat-icon class="add-icon"> {{ icon || 'add' }}</mat-icon>
    </button>
  </div>
</div>
<!-- /Float button -->
